var _rect, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _ellipse, _circle5, _circle6, _path5, _path6, _path7, _ellipse2, _path8, _path9, _ellipse3, _path0, _ellipse4, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatKids(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 18,
    fill: "#fff1cc"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 14,
    y: 14,
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C1694F",
    d: "M25 22h-.253c.16-.798.253-1.633.253-2.5 0-5.247-3.134-9.5-7-9.5s-7 4.253-7 9.5c0 .867.093 1.702.253 2.5H11c-2 3-1.502 8.056.122 9C18 35 14 29 18 29s0 6 6.878 2c1.624-.944 2.122-6 .122-9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1694F",
    d: "M23.667 20.458c-.177-1.544.317-3.562.255-5.25C22.535 16.292 19.947 17 18 17s-4.51-.708-5.897-1.792c-.062 1.688.407 3.706.23 5.25-.458 4 2.353 7.184 5.667 7.184s6.125-3.184 5.667-7.184z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1694F",
    d: "M12.373 14s-5 1-6 7 3.419 6.581 5 5c2-2 0-4 0-4s1-5 1-8zm11.254 0s5 1 6 7-3.419 6.581-5 5c-2-2 0-4 0-4s-1-5-1-8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0041E",
    d: "M13 13c-2 0-1 1-1 2s1 3 3 2c0 0-1 2-1 5 0 0 2 0 3 2 0 0 1-7 1-9s-4-2-5-2zm10 0c2 0 1 1 1 2s-1 3-3 2c0 0 1 2 1 5 0 0-2 0-3 2 0 0-1-7-1-9s4-2 5-2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#C1694F",
    cx: 11,
    cy: 4,
    r: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#662113",
    cx: 11,
    cy: 4,
    r: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#C1694F",
    cx: 25,
    cy: 4,
    r: 4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#662113",
    cx: 25,
    cy: 4,
    r: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#C1694F",
    cx: 18,
    cy: 8.5,
    rx: 8,
    ry: 7.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "#292F33",
    cx: 15,
    cy: 8,
    r: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fill: "#292F33",
    cx: 21,
    cy: 8,
    r: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D99E82",
    d: "M18.058 9.563c-6.808 0-4.612 5.562-.147 5.562 4.464 0 6.955-5.562.147-5.562z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#292F33",
    d: "M16.737 11.065l.526.911c.328.567 1.147.567 1.474 0l.526-.911c.328-.567-.082-1.277-.737-1.277h-1.052c-.655 0-1.064.709-.737 1.277z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#934035",
    d: "M11.265 27.002c-.166 0-.327-.082-.422-.231-.148-.233-.08-.542.153-.69.04-.025 1.027-.688.997-2.022-.023-.991-.933-1.641-.942-1.646-.121-.085-.2-.221-.213-.368-.205-2.36.65-4.709.687-4.809.096-.258.381-.391.642-.296.259.096.392.383.296.642-.008.021-.761 2.099-.644 4.165.375.322 1.146 1.124 1.174 2.289.044 1.91-1.398 2.851-1.459 2.89-.085.051-.178.076-.269.076zm13.471 0c-.092 0-.186-.025-.269-.078-.062-.039-1.504-.979-1.46-2.89.027-1.165.799-1.967 1.174-2.289.118-2.072-.636-4.143-.644-4.164-.096-.259.036-.547.296-.643.257-.095.546.037.642.296.037.099.893 2.448.688 4.809-.013.149-.092.284-.215.369-.008.005-.918.654-.94 1.646-.031 1.353.986 2.016.997 2.022.232.148.302.457.153.69-.096.15-.257.232-.422.232zM24.665 22h.01-.01z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-45.001 11.121 30.5)",
    fill: "#C1694F",
    cx: 11.122,
    cy: 30.5,
    rx: 4.5,
    ry: 5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#D99E82",
    d: "M13.349 33.227c-1.054 1.054-2.906.912-4.137-.318-1.23-1.23-1.373-3.082-.318-4.137 1.054-1.054 2.906-.912 4.137.318 1.23 1.231 1.372 3.083.318 4.137z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D99E82",
    d: "M12.889 32.768c-.781.781-2.206.623-3.182-.354-.976-.976-1.135-2.401-.354-3.182.781-.781 2.206-.623 3.182.354s1.135 2.401.354 3.182z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-45.001 24.878 30.5)",
    fill: "#C1694F",
    cx: 24.878,
    cy: 30.5,
    rx: 5,
    ry: 4.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#D99E82",
    d: "M22.651 33.227c1.054 1.054 2.906.912 4.137-.318 1.23-1.23 1.373-3.082.318-4.137-1.054-1.054-2.906-.912-4.137.318-1.23 1.231-1.372 3.083-.318 4.137z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-45.001 24.878 31)",
    fill: "#D99E82",
    cx: 24.878,
    cy: 31,
    rx: 2.5,
    ry: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#292F33",
    d: "M18.087 14.138c-1.28 0-2.249-.947-2.264-.961-.098-.098-.098-.255 0-.353s.255-.098.353-.001c.075.074 1.849 1.797 3.647 0 .098-.098.256-.098.354 0s.098.256 0 .354c-.721.721-1.445.961-2.09.961z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#934035",
    d: "M15.95 29.727c-.185 0-.362-.103-.449-.28-2.274-4.635-6.795-3.15-6.986-3.086-.262.091-.545-.049-.635-.311-.09-.261.048-.544.309-.635.055-.02 5.543-1.845 8.21 3.592.122.247.02.547-.229.669-.071.034-.147.051-.22.051zm4.101 0c-.065 0-.132-.013-.195-.04-.255-.108-.373-.401-.265-.655 2.255-5.301 8.141-3.641 8.198-3.623.265.077.416.354.339.619-.077.267-.362.414-.619.341-.207-.061-5.096-1.42-6.998 3.054-.081.189-.266.304-.46.304z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatKids);
export default __webpack_public_path__ + "static/media/cat-kids.406785dd036a630bb4a2d6ad7b6d697a.svg";
export { ForwardRef as ReactComponent };